<template>
  <div class="mt4 overflow-hidden h-auto">
    <p>Which hymnal are you using?</p>
    <div class="list mh0 ph0 flex flex-column items-stretch">
      <router-link
        v-for="hymnal in hymnals" :key="hymnal.id"
        :to="{
          name: 'hymnal',
          params: {
            hymnalUrl: hymnal.url
          }
        }"
        class="f4 glow hover-bg-blue hover-white link ba ph3 pv2 mb2 dib blue pointer br2 self-stretch"
        >{{ hymnal.name}}
        </router-link>
    </div>
    <div>Updated: November 2024</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import hymns from '@/assets/hymnals_2018_03_03.json'

export default {
  name: 'home',
  data () {
    return {
      // hymns: hymns,
      hymnalUrl: undefined
    }
  },
  computed: {
    ...mapGetters({
      hymnals: 'hymnals/hymnals'
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
